import { DecimalPipe, PercentPipe } from '@angular/common';
import { Pipe, PipeTransform } from '@angular/core';

import { I18nLocaleFactory } from '../i18n/i18n.module';
import { I18nService } from '../i18n/i18n.service';

@Pipe({
    name: 'cmpsNumber',
})
export class CmpsDecimalPipe implements PipeTransform {
    constructor(private readonly _i18nService: I18nService) {}

    transform(value: any, digits?: string): string | null {
        const locale = I18nLocaleFactory(this._i18nService);
        return new DecimalPipe(locale).transform(value, digits);
    }
}

// TODO revise tl
const ExponentSymbolMap = [{ value: 1e3, symbol: 'K' }];

export function truncateWithSuffix(
    value: any,
    digits: string,
    pipe: PipeTransform,
    format: 'number' | 'percent',
): string {
    // eslint-disable-next-line @typescript-eslint/no-for-in-array
    for (const i in ExponentSymbolMap) {
        const item = ExponentSymbolMap[i];
        if (value >= item.value || value <= -item.value) {
            const v = value / item.value;
            // eslint-disable-next-line @typescript-eslint/restrict-plus-operands
            return (
                // eslint-disable-next-line @typescript-eslint/restrict-plus-operands
                pipe.transform(format === 'percent' ? v / 100 : v, '1.0-1') +
                item.symbol
            );
        }
    }
    return pipe.transform(format === 'percent' ? value / 100 : value, digits);
}

@Pipe({
    name: 'cmpsNumberWithSuffix',
})
export class CmpsDecimalWithSuffixPipe implements PipeTransform {
    constructor(private readonly _i18nService: I18nService) {}

    transform(value: any, digits?: string): string | null {
        const locale = I18nLocaleFactory(this._i18nService);
        return truncateWithSuffix(
            value,
            digits,
            new DecimalPipe(locale),
            'number',
        );
    }
}

@Pipe({
    name: 'cmpsPercent',
})
export class CmpsPercentPipe implements PipeTransform {
    constructor(private readonly _i18nService: I18nService) {}

    transform(value: any, digits?: string): string | null {
        const locale = I18nLocaleFactory(this._i18nService);
        return new PercentPipe(locale).transform(value, digits);
    }
}

@Pipe({
    name: 'cmpsPercentWithSuffix',
})
export class CmpsPercentWithSuffixPipe implements PipeTransform {
    constructor(private readonly _i18nService: I18nService) {}

    transform(value: any, digits?: string): string | null {
        const locale = I18nLocaleFactory(this._i18nService);
        return truncateWithSuffix(
            value,
            digits,
            new PercentPipe(locale),
            'percent',
        );
    }
}
